let Cookies = require('js-cookie');
let $floater = $('.floater');
let cookieKey = 'ignored-cookie-' + $floater.data('post-id');

export default {
  fire() {
    if ($floater.length === 0) {
      return;
    }

    if (Cookies.get(cookieKey)) {
      return;
    }

    $floater.find('.floater-content').on('click', (e) => {
      e.stopPropagation();
    });

    $('.floater, .floater-close').on('click', function () {
      Cookies.set(cookieKey, true);
      $floater.css('display', 'none');
    });

    $floater.css('display', 'flex').hide().fadeIn();
  },
};



// WEBPACK FOOTER //
// ./scripts/components/floater.js